/**
 * The below file is the Station service which contains method for doing the API calls.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import fetch from "auth/FetchInterceptor";
import {
  Application_Json,
  Authorization_Token,
  Get_All_Station,
} from "constants/ApiConstant";
import { format } from "react-string-format";
import { AUTH_TOKEN } from "redux/constants/Auth";

const StationService = {};

//#region Method for Station dropdown

/**
 * Method for getting the Station dropdown
 * @param {any} param API Parameters
 * @returns Fetch Method
 */
StationService.getAllStation = function (param) {
  return fetch({
    url: Get_All_Station,
    method: "get",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
    params: param,
  });
};

//#endregion Method for Station dropdown.

export default StationService;
